import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { CategoryService, Tier, TierAware } from '@shared-data';
import { ActivatedRoute } from '@angular/router';
import { ColumnOptions, MessageService, NamedEntity } from '@shared';
import {
  aLaCarteProductType,
  ExportOption,
  ltoProductType,
  pricingProductTypes,
} from '../../constants';
import { BasePricingChangesetComponent } from '../base-pricing-changeset/base-pricing-changeset.component';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.scss',
})
export class PricingComponent extends TierAware implements OnInit {
  locked: boolean = false;

  restaurantId?: string;

  productTypes = pricingProductTypes;

  _productType!: NamedEntity;

  get productType() {
    return this._productType;
  }
  set productType(v: NamedEntity) {
    this._productType = v;
    if (v && this.restaurantId) {
      this.fetchCategories();
    }
  }

  defaultCategory = new NamedEntity('-1', 'Category (All)');
  selectedCategory: NamedEntity = this.defaultCategory;

  categories: NamedEntity[] = [];

  component?: BasePricingChangesetComponent;

  showLoadRbiRecommendationsConfirmation: boolean = false;
  rbiRecommendationsDate?: Date | null = null;

  constructor(
    injector: Injector,
    private activatedRoute: ActivatedRoute,
    private categoryService: CategoryService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
  ) {
    super(injector);
    this.activatedRoute.params.subscribe((params) => {
      const queryParams = this.activatedRoute.snapshot.queryParams;
      this.productType = queryParams['isLto']
        ? ltoProductType
        : aLaCarteProductType;
    });
  }

  override ngOnInit(): void {
    this.subscribeToPendingChangesChange();

    super.ngOnInit();
  }

  updatePendingChanges() {
    this.globalEventsService.updatePendingChanges();
  }

  subscribeToPendingChangesChange() {
    this.globalEventsService.pendingChangesUpdated$.subscribe(() => {
      this.updateParameters();
    });
  }

  override afterTierChange(tier: Tier): void {
    if (tier) {
      this.restaurantId = tier.kingRestaurantId;
      this.rbiRecommendationsDate = tier.kingRestaurantLastRbiPriceUpdate;
      this.locked = tier.isLocked ?? false;
      this.fetchCategories();
    }
  }

  updateParameters() {
    const queryParams = {
      restaurantId: this.restaurantId,
      locked: this.locked,
      category:
        this.selectedCategory.id !== '-1' ? this.selectedCategory.id : null,
      _refresh: Date.now(),
    };
    this.router.navigate([this.productType.id], {
      relativeTo: this.activatedRoute,
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  fetchCategories() {
    this.categoryService
      .getCategories(this.restaurantId ?? '', this.productType.id)
      .subscribe({
        next: (response) => {
          this.categories = response.data;
          if (this.selectedCategory.id !== '-1') {
            //restore selected category if exists
            const cat = this.categories.find(
              (c) => c.name === this.selectedCategory.name,
            );
            this.selectedCategory = cat ?? this.defaultCategory;
          }

          this.updateParameters();
        },
        error: (err) => this.messageService.error(err),
      });
  }

  onActivate(componentRef: any) {
    this.component = componentRef as BasePricingChangesetComponent;
    this.cdr.detectChanges();
  }

  saveChanges() {
    if (this.component) {
      this.component.saveChanges();
    }
  }

  exportToExcel(exportOption: ExportOption) {
    if (this.component) {
      this.component.exportToExcel(exportOption);
    }
  }

  updateFontSize(fontSize: number) {
    if (this.component) {
      this.component.fontSize = fontSize;
    }
  }

  loadRbiRecommendations() {
    if (this.component) {
      this.component.loadRbiRecommendations();
    }
  }
}
